/* eslint-disable no-useless-escape */
import { updateShopData } from '../../apis/shop.service'
import { ERROR_UPDATE_SHOP_DATA, INPUT_PHONE_MAX_LENGTH, INPUT_SIREN_MAX_LENGTH, KEYWORDS } from '../../constants'
import { isEmail } from '../../utils/tools'
import { formatAddress, isValidAddress } from '../../utils/shopUtils'
import { getGeocodeByAddress } from 'src/apis/backend'

export const handleChangeAddressCompany = (addressCompany, component) => {
  component.setState(prevState => {
    const { validationMessage } = prevState;
    return {
      addressCompany,
      validationMessage: { ...validationMessage, companyAddressError: 'is-invalid' }
    };
  });
};

export const handleChangeAddressShop = (addressShop, component) => {
  component.setState(prevState => {
    const { validationMessage } = prevState;
    return {
      addressShop,
      validationMessage: { ...validationMessage, shopAddressError: 'is-invalid' }
    };
  });
};

export const handleSelectAddressCompany = async (addressCompany, component) => {
  const geoCodeAddress = await getGeocodeByAddress(addressCompany);
  const arrayAddress = await geoCodeAddress[0].address_components;
  component.setState(prevState => {
    const { validationMessage, legal } = prevState;
    if (isValidAddress(arrayAddress)) {
      return {
        validationMessage: { ...validationMessage, companyAddressError: 'is-invalid' }
      };
    }
    return {
      legal: {
        ...legal,
        address: formatAddress(arrayAddress)
      },
      addressCompany,
      validationMessage: { ...validationMessage, companyAddressError: 'is-valid' }
    };
  });
};

export const handleSelectAddressShop = async (addressShop, component) => {
  const geoCodeAddress = await getGeocodeByAddress(addressShop);
  const arrayAddress = await geoCodeAddress[0].address_components;
  const { lat, lng } = geoCodeAddress[0].geometry.location
  await component.setState(prevState => {
    const { shop, configurations, validationMessage } = prevState;

    if (isValidAddress(arrayAddress)) {
      return {
        validationMessage: { ...validationMessage, shopAddressError: 'is-invalid' }
      };
    }
    const address = formatAddress(arrayAddress);
    const { keyWords = '' } = configurations;
    const { city, street } = shop;
    let keyWordsToReturn = keyWords.replace(`${city}, `, '').replace(`${street}, `, '');
    keyWordsToReturn = `${address.streetNumber} ${address.street}, ${address.city}, ${address.country} ${keyWordsToReturn}`;
    return {
      shop: {
        address: {
          ...address,
          location: {
            latitude: lat,
            longitude: lng
          }
        },
        ...shop
      },
      addressShop,
      configurations: {
        ...configurations,
        keyWords: keyWordsToReturn
      },
      validationMessage: { ...validationMessage, shopAddressError: 'is-valid' }
    };
  });
};

export const onChangeShopData = ({ target }, component) => {
  const { id, value } = target;
  component.setState(prevState => {
    const { shop, configurations, validationMessage } = prevState;
    let statusError = 'is-invalid';
    if (value) {
      switch (id) {
        case 'email': {
          statusError = isEmail(value) ? 'is-valid' : 'is-invalid';
          break;
        }
        case 'number': {
          // const noSpaceNumber = value.replace(/ /g, '');
          statusError = value.length === INPUT_PHONE_MAX_LENGTH ? 'is-valid' : 'is-invalid';
          // statusError = noSpaceNumber.length === INPUT_PHONE_MAX_LENGTH ? 'is-valid' : 'is-invalid';
          break;
        }
        default: {
          statusError = value.length > 0 ? 'is-valid' : 'is-invalid';
          break;
        }
      }
    }

    const shopToReturn = {
      ...shop,
      [id]: value
    };
    if (id === 'name') {
      const { name } = shop;
      const { keyWords = '' } = configurations;
      let keyWordsToReturn = keyWords.replace(`${name}, `, '');
      keyWordsToReturn = `${value}, ${keyWordsToReturn}`;
      return {
        shop: shopToReturn,
        configurations: {
          ...configurations,
          keyWords: keyWordsToReturn
        },
        validationMessage: { ...validationMessage, [id]: statusError }
      };
    }
    return {
      shop: shopToReturn,
      validationMessage: { ...validationMessage, [id]: statusError }
    };
  });
};

export const onChangeKeywords = ({ target }, component) => {
  const { id, value } = target;
  component.setState(prevState => {
    const { configurations } = prevState;
    return {
      configurations: {
        ...configurations,
        [id]: value
      }
    };
  });
};

export const onChangeConfigData = ({ target }, component) => {
  const { id, value } = target;
  component.setState(prevState => {
    const { configurations, validationMessage } = prevState;
    let statusError = '';
    if (id === 'businessType') {
      statusError = value !== '' ? 'is-valid' : 'is-invalid';
      const { keyWords = '', businessType } = configurations;
      let keyWordsToReturn = keyWords.replace(`${KEYWORDS[businessType]}, `, '');
      keyWordsToReturn =
        value !== '' ? `${KEYWORDS[value]}, ${keyWordsToReturn}` : keyWordsToReturn;
      return {
        configurations: {
          ...configurations,
          [id]: value,
          keyWords: keyWordsToReturn
        },
        validationMessage: { ...validationMessage, [id]: statusError }
      };
    }
    return {
      configurations: {
        ...configurations,
        [id]: value
      },
      validationMessage: { ...validationMessage, [id]: statusError }
    };
  });
};

export const onChangeData = ({ target }, component) => {
  const { id } = target;
  const { value } = target;
  component.setState(prevState => {
    const { configurations, legal, validationMessage } = prevState;
    let statusError = 'is-invalid';

    if (value) {
      switch (id) {
        case 'registreCommerceNumero': {
          statusError = value.length === INPUT_SIREN_MAX_LENGTH ? 'is-valid' : 'is-invalid';
          break;
        }
        case 'companyType': {
          statusError = value !== '' ? 'is-valid' : 'is-invalid';
          break;
        }
        case 'businessType': {
          statusError = value !== '' ? 'is-valid' : 'is-invalid';
          break;
        }
        default: {
          statusError = value.length > 0 ? 'is-valid' : 'is-invalid';
          break;
        }
      }
    }

    const legalToReturn = {
      ...prevState.legal,
      [id]: value
    };
    if (id === 'companyName') {
      const { companyName } = legal;
      const { keyWords = '' } = configurations;
      let keyWordsToReturn = keyWords.replace(`${companyName}, `, '');
      keyWordsToReturn = `${value}, ${keyWordsToReturn}`;
      return {
        legal: legalToReturn,
        configurations: {
          ...configurations,
          keyWords: keyWordsToReturn
        },
        validationMessage: { ...validationMessage, [id]: statusError }
      };
    }
    return {
      legal: legalToReturn,
      validationMessage: { ...validationMessage, [id]: statusError }
    };
  });
};

export const onChangeCheck = ({ target }, component) => {
  const { id, checked } = target;
  component.setState(prevState => {
    const { chosenTechs, validationMessage } = prevState;
    let isCheck = 'is-invalid';
    chosenTechs &&
      Object.keys(chosenTechs).forEach(tech => {
        isCheck = chosenTechs[tech] && tech !== id ? 'is-valid' : isCheck;
      });
    if (checked) {
      return {
        chosenTechs: {
          ...chosenTechs,
          [id]: true
        },
        validationMessage: { ...validationMessage, technoCheck: 'is-valid' }
      };
    }
    return {
      chosenTechs: {
        ...chosenTechs,
        [id]: false
      },
      validationMessage: { ...validationMessage, technoCheck: isCheck }
    };
  });
};

export const handleSubmit = async (e, component) => {
  const { openErrorModal } = component.props;
  try {
    if (component.isPhoneIncorrect) {
      return
    }
    e.preventDefault();
    component.setState({ isLoadingData: true });
    const { validationMessage, legal, shop, configurations, chosenTechs } = component.state;
    let isValidForm = true;
    validationMessage &&
      Object.keys(validationMessage).forEach(id => {
        if ((id !== 'number' && validationMessage[id] === 'is-invalid') || !validationMessage[id]) {
          isValidForm = false;
          component.setState(prevState => {
            const { validationMessage } = prevState;
            return { validationMessage: { ...validationMessage, [id]: 'is-invalid' } };
          });
        }
      });
    if (isValidForm) {
      await updateShopData(legal, shop, configurations, chosenTechs);
    }
    component.setState({ isLoadingData: false });
  } catch (error) {
    openErrorModal(ERROR_UPDATE_SHOP_DATA);
  }
};
export const handleChangePhoneNumber = (phone, component) => {
  component.setState(prevState => {
    const { shop } = prevState;
    return {
      shop: {
        ...shop, number: phone
      },
      touched: true
    };
  });
};